import { object, array, number } from '@gogame/schemas';

import { IDS, BUSINESS_PARTNERS } from './constants';

export const validationSchema = object({
  [IDS]: array(number()),
  [BUSINESS_PARTNERS]: array(number()).required(
    'Business Partners is required'
  ),
});
